import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../component/Layout";
import MasterGrid from "../../component/MasterGrid";
import { Box } from '@mui/material';

/* import members' info */
import { members_113 } from "./info/alumni/113";
import { members_112 } from "./info/alumni/112";
import { members_111 } from "./info/alumni/111";
import { members_110 } from "./info/alumni/110";


const Alumni = () => {
    const { t } = useTranslation();

    const [loadedYears, setLoadedYears] = useState([113,112,111,110]); // Initially load the first year
    const [allMembers, setAllMembers] = useState({
      113: members_113,
      112: members_112,
      111: members_111,
      110: members_110,
    });

    const lastYearRef = useRef(null);

    const loadMoreData = () => {
        const nextYear = loadedYears[loadedYears.length - 1] - 1;
        if (nextYear >= 110) {
            setLoadedYears([...loadedYears, nextYear]);
        }
    };

    useEffect(() => {
        const handleIntersection = (entries) => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                loadMoreData();
            }
        };

        const observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1, // Adjust as needed
        });

        if (lastYearRef.current) {
            observer.observe(lastYearRef.current);
        }

        return () => {
            if (lastYearRef.current) {
                observer.unobserve(lastYearRef.current);
            }
        };
    }, [loadedYears]);

    return (
        <Layout>
            {loadedYears.map((year, index) => (
                <Box key={year} padding={2} ref={index === loadedYears.length - 1 ? lastYearRef : null}>
                    <MasterGrid title={year + " " + t("page.member.Alumni.title")} members={allMembers[year]} />
                </Box>
            ))}
        </Layout>
    );
}

export default Alumni;
